import { computed } from 'vue';
import { storeToRefs } from 'pinia';

import { useUserStore } from '@/stores/user';
import type { CorpUserSegmentation, SegmentationDimension } from '@/types';

export type SegmentedFamily =
  | 'cards'
  | 'vehicles'
  | 'users'
  | 'teams'
  | 'cost_centers'
  | 'projects'
  | 'card_templates';

const SCOPED_FAMILIES: Record<SegmentationDimension, readonly SegmentedFamily[]> = {
  cost_center: ['cards', 'vehicles', 'cost_centers'],
  project: ['cards', 'vehicles', 'projects'],
  team: ['cards', 'users', 'teams'],
  product: ['cards', 'card_templates'],
};

const GLOBAL: CorpUserSegmentation = { dimension: null, values: [] };

export function useActorSegmentation() {
  const { meData } = storeToRefs(useUserStore());

  const segmentation = computed<CorpUserSegmentation>(() => meData.value?.segmentation ?? GLOBAL);
  const dimension = computed(() => segmentation.value.dimension);
  const values = computed(() => segmentation.value.values);
  const isGlobal = computed(() => dimension.value === null);

  const scopes = (family: SegmentedFamily): boolean =>
    dimension.value !== null && SCOPED_FAMILIES[dimension.value].includes(family);

  return { dimension, values, isGlobal, scopes };
}
